import React from 'react';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import Sell from './Sell';

function SellIndex() {
  return (
    <div>
      <Navbar />
      <Sell />
      <Footer />
    </div>
  );
}

export default SellIndex;
